import PropTypes from 'prop-types'
import React, { PureComponent, createRef } from 'react'

export default class BaselineTextarea extends PureComponent {
  constructor(props) {
    super(props)

    this.textarea = createRef()
  }

  componentDidMount() {
    this.autoGrow()
    // this.textarea.current.focus()
    window.getSelection().empty()
  }

  componentDidUpdate() {
    this.autoGrow()
    // this.textarea.current.focus()
    window.getSelection().empty()
  }

  autoGrow() {
    this.textarea.current.style.height = 'fit-content'
    this.textarea.current.style.height =
      this.textarea.current.scrollHeight + 10 + 'px'
  }

  goFalse() {
    return false
  }

  render() {
    return (
      <textarea
        ref={this.textarea}
        value={this.props.text}
        id="baseline-text"
        readOnly={true}
        contentEditable={false}
        // readOnly={!this.props.editing}
        // contentEditable={this.props.editing}
        onChange={this.autoGrow}
        onCut={this.goFalse}
        onPaste={this.goFalse}
        onKeyDown={this.goFalse}
        onDragEnter={this.goFalse}
        onDragLeave={this.goFalse}
        onDragOver={this.goFalse}
        onDrop={this.goFalse}
      />
    )
  }
}

BaselineTextarea.propTypes = {
  text: PropTypes.string,
  targetText: PropTypes.string,
  editing: PropTypes.bool,
  bodyChangeText: PropTypes.func,
}
